import { Button } from '@music-vine/cadence/ui';
import type { Plan } from '@/fixtures/plans';
import { UpdatePaymentButton } from '@/components/UpdatePaymentButton';
import { useOverduePayment } from '@/hooks/billing/useOverduePayment';
export const OverduePaymentNotice = ({
  accountType
}: {
  accountType: Plan['name'];
}) => {
  const {
    overduePayment
  } = useOverduePayment();
  const {
    id: overduePaymentId
  } = overduePayment ?? {};
  if (!overduePaymentId) {
    return null;
  }
  return <div className="flex flex-wrap gap-2 bg-red-100 p-5 xl:px-6 dark:bg-red-950" data-sentry-component="OverduePaymentNotice" data-sentry-source-file="OverduePaymentNotice.tsx">
      <span className="text-black text-xs xl:text-sm dark:text-white">
        Your subscription is on hold due to payment issue.
      </span>
      <Button asChild size="sm" variant="contrast" data-sentry-element="Button" data-sentry-source-file="OverduePaymentNotice.tsx">
        <UpdatePaymentButton data-sentry-element="UpdatePaymentButton" data-sentry-source-file="OverduePaymentNotice.tsx">Update payment method</UpdatePaymentButton>
      </Button>
    </div>;
};